export interface Category {
  Name: string;
  Id: string;
}

export interface CategorySelection {
  Name: string;
  Id: string;
  Selected: string;
}

export interface MaxEvent {
  Id: string;
  Title: string;
  Description: string;
  Location: string;
  Price: string;
  Start: Date;
  End: Date;
  Date: string;
  StartTime: string;
  EndTime: string;
  CategoryNameList: Array<string>;
  Website: string;
  Phone: string;
  Email: string;
}

export interface Week {
  DayList: Array<Day>;
  WeekNum: number;
}

export interface Day {
  Day: number;
  Date: Date;
  EventList: Array<MaxEvent>;
  DayOfWeek: number;
}

export interface MaxSubmitEvent {
  Name: string;
  Date: string;
  StartTime: string;
  EndTime: string;
  CategorySelectionList: Array<CategorySelection>;
  CategoryNameList: Array<string>;
  Description: string;
  Price: string;
  Location: string;
  Website: string;
  Email: string;
  Phone: string;
}

export class Util {
  static ConvertTo24Hour (lsTime: string) {
    let lsR: string = lsTime.toLowerCase()
    const lnHour: number = parseInt(lsTime.substr(0, 2))
    if (lsR.indexOf('am') !== -1 && lnHour === 12) {
      lsR = lsR.replace('12:', '0:')
    }

    if (lsR.indexOf('pm') !== -1 && lnHour < 12) {
      lsR = lsR.replace(lnHour.toString() + ':', (lnHour + 12).toString() + ':')
    }

    return lsR.replace(/(am|pm)/, '')
  }

  static ConvertToAMPM (lsTime: string) {
    let lsR: string = lsTime
    const lnHour: number = parseInt(lsTime.substr(0, 2))
    let lsAMPM = 'AM'
    if (lnHour === 0) {
      lsR = lsR.replace('00:', '12:')
      lsR = lsR.replace('0:', '12:')
    } else if (lnHour > 12) {
      lsR = lsR.replace(lnHour.toString() + ':', (lnHour - 12).toString() + ':')
      lsAMPM = 'PM'
    } else if (lnHour === 12) {
      lsAMPM = 'PM'
    }

    return lsR.trim() + ' ' + lsAMPM
  }
}
